import { createContext } from 'react';
import { IObservableValue } from 'mobx/lib/internal';

export const IsNestedPopperOpenContext = createContext<IObservableValue<boolean>>(undefined);
